import { FormattedMessage } from "react-intl";
const AdvancedAdminControls = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.advancedAdminControls.content.body"
                    defaultMessage="Manage users and security at scale with advanced governance controls like advanced encryption and Shadow IT controls."
                />
            </p>
        </div>
    );
};
export default AdvancedAdminControls;
